import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Warehouses")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openNewWarehousePopin();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" new warehouse ")], 1), _vm.canEditDefaultDepartureContinent ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openDefaultDeparturePopin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      dark: "",
      small: ""
    }
  }, [_vm._v("mdi-warehouse")]), _vm._v(" Defaults consolidations/departures ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a name...",
      "append-icon": "fa-search",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.warehousesCount
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id_warehouse",
      "items-per-page": +_vm.searchCriterias.paging.limits,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.isPreventInvoice",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.isPreventInvoice ? _c("span", {
          staticClass: "badge warning --small"
        }, [_vm._v(" DONT generate FR invoice ")]) : _c("span", {
          staticClass: "badge neutral --small"
        }, [_vm._v("Generate FR invoice")])];
      }
    }, {
      key: "item.defaultIntendedCountries",
      fn: function fn(_ref2) {
        var _item$defaultIntended, _item$defaultIntended2, _item$defaultIntended3, _item$defaultIntended4;
        var item = _ref2.item;
        return [((_item$defaultIntended = item.defaultIntendedCountries) === null || _item$defaultIntended === void 0 ? void 0 : _item$defaultIntended.length) !== 1 ? _c("div", [_vm._v(" " + _vm._s(((_item$defaultIntended2 = item.defaultIntendedCountries) === null || _item$defaultIntended2 === void 0 ? void 0 : _item$defaultIntended2.length) > 1 ? "".concat(item.defaultIntendedCountries.length, " countries") : "".concat(item.defaultIntendedCountries.length, " country")) + " ")]) : _vm._e(), ((_item$defaultIntended3 = item.defaultIntendedCountries) === null || _item$defaultIntended3 === void 0 ? void 0 : _item$defaultIntended3.length) > 0 && ((_item$defaultIntended4 = item.defaultIntendedCountries) === null || _item$defaultIntended4 === void 0 ? void 0 : _item$defaultIntended4.length) < 8 ? _c("div", {
          staticClass: "text-smaller"
        }, _vm._l(item.defaultIntendedCountries, function (country, i) {
          return _c("span", {
            key: "whCountry-".concat(item.id_warehouse, "-").concat(country.id, "-").concat(i)
          }, [_vm._v(" " + _vm._s(country.name) + _vm._s(i !== item.defaultIntendedCountries.length - 1 ? ", " : "") + " ")]);
        }), 0) : _vm._e()];
      }
    }, {
      key: "item.isInboundCompatible",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.isInboundCompatible ? _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "green"
          }
        }, [_vm._v("fa-check")])], 1) : _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-times")])], 1)];
      }
    }, {
      key: "item.action",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.canEditWarehouse(item) ? _c("div", {
          staticClass: "table-actions"
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            small: "",
            title: "Edit"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.openEditWarehousePopin(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")]), _c(VIcon, {
          attrs: {
            small: "",
            title: "Delete"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.deleteWarehouse(item);
            }
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: +_vm.searchCriterias.paging.limits,
      totalNumber: _vm.warehousesCount
    }
  })], 1)])]) : _vm._e(), _vm.warehousePopinShown ? _c("WarehousePopin", {
    ref: "warehousePopin",
    attrs: {
      listCountries: _vm.countries,
      listStates: _vm.states,
      stockType: "Stock"
    },
    on: {
      closed: _vm.closeWarehousePopin
    }
  }) : _vm._e(), _c("DefaultDeparturePopin", {
    key: _vm.reloadWarehouseDefaultDeparturePopinShown,
    ref: "DefaultDeparturePopin"
  }), _c("Confirm", {
    ref: "confirm"
  })], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };